import React from 'react';
import {CompositeDecorator} from 'draft-js';

const HANDLE_REGEX = /[@]\w+\s\w+|[@]\w+/g;
const HASHTAG_REGEX = /[#]\w+/g;
const HASHTAG_REGEX_INPUT = /[#]\w{3,}/g;
const PLUS_REGEX = /[+]\d+/g;

function handleStrategy(contentBlock, callback, contentState) {
  findWithRegex(HANDLE_REGEX, contentBlock, callback);
}

function hashtagStrategy(contentBlock, callback, contentState) {
  findWithRegex(HASHTAG_REGEX, contentBlock, callback);
}
function hashtagInputStrategy(contentBlock, callback, contentState) {
  findWithRegex(HASHTAG_REGEX_INPUT, contentBlock, callback);
}

function plusStrategy(contentBlock, callback, contentState) {
  findWithRegex(PLUS_REGEX, contentBlock, callback);
}

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}


const HandleSpan = props => {
  return (
    <span {...props} style={{color:'#008bff', fontWeight:600}}>
      {props.children}
    </span>
  );
};

const HashtagSpan = props => {
  return (
    <span {...props} style={{color:'#b4b4b4', fontWeight:600}}>
      {props.children}
    </span>
  );
};

const PlusSpan = props => {
  return (
    <span {...props} style={{color:'#008bff', border:'1px solid', borderRadius:'12px', padding:'2px 7px', fontSize:'14px'}}>
      {props.children}
    </span>
  );
};

export const decorator = new CompositeDecorator([
  {
    strategy: handleStrategy,
    component: HandleSpan,
  },
  {
    strategy: hashtagStrategy,
    component: HashtagSpan,
  },
  {
    strategy: plusStrategy,
    component: PlusSpan,
  },
]);

export const decoratorArray = [
  // {
  //   strategy: handleStrategy,
  //   component: HandleSpan,
  // },
  // {
  //   strategy: hashtagInputStrategy,
  //   component: HashtagSpan,
  // },
  {
    strategy: plusStrategy,
    component: PlusSpan,
  },
];